import {clientRequest} from '../apiClient';

const loginGoogle = (googleObject: any, language: string) => {
  return clientRequest<any>({
    url: '/auth/google',
    options: {method: 'POST'},
    body: {credentials: googleObject, language}
  });
};

export default loginGoogle;
